<template>
    <group-management-plans-catalog
        v-if="isGroup"
        :parent-group-booking="parentGroupBooking"
    />
    <storefront-catalog
        v-else
        :key="activeFacility.id"
        :catalog="catalog"
        :storefront-prefix="storefrontPrefix"
        root
    />
</template>

<script setup lang="ts">
import { inject } from 'vue'
import StorefrontCatalog from '~/components/Storefront/StorefrontCatalog.vue'
import { useActiveFacility } from '~/composables/use-active-facility'
import GroupManagementPlansCatalog from '~/components/GroupManagement/GroupManagementPlansCatalog.vue'
import { useLayoutMode } from '~/composables/use-layout-mode'

const { isGroup } = useLayoutMode()

// Use the active facility for the key so we rerender in the catalog component
// in order to get a new title - yes it's hacky, but it works
const activeFacility = useActiveFacility()

let catalog = null
let storefrontPrefix = null
let parentGroupBooking = null

// Trying to avoid some console errors here
// Don't inject the storefront stuff if in group mode and vice versa
if (isGroup.value) {
    parentGroupBooking = inject('GROUP_CONTRACT')
} else {
    catalog = inject('CATALOG')
    storefrontPrefix = inject('STOREFRONT_PREFIX')
}
</script>
